/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-05 13:56:13
 * @LastEditTime: 2020-08-05 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/service/templateService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";

/*
 * 获取template页面数据
 */
export function getTemplateDataApi(Info) {
  return request({
    url:
      "/api/v1/templates?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET",
    data: Info
  });
}

/*
 * 新建template页面数据
 */
export function createTemplate(data) {
  return request({
    url: "/api/v1/templates",
    method: "POST",
    data: data
  });
}
/*
 * 编辑template页面数据
 */
export function editTemplate(data) {
  return request({
    url: "/api/v1/templates/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取template数据详情
 */
export function getTemplateInfo(id) {
  return request({
    url: "/api/v1/templates/" + id,
    method: "GET"
  });
}
/*
 * 删除template数据
 */
export function deleteTemplate(id) {
  return request({
    url: "/api/v1/templates/" + id,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/service/templateService.js